import axios from 'axios'
import router from './router'
import helper from '@/Helper'
import swal from 'sweetalert'
import i18n from './lang/i18n'
const api = axios.create({
  baseURL: process.env.URL_API,
  transformRequest: [function (data, headers) {
    headers['Authorization'] = 'Bearer' + helper.getToken()
    headers['Content-Type'] = 'application/json'
    headers['X-localization'] = helper.getLanguage()
    if (data instanceof FormData) {
      return data
    }
    return JSON.stringify(data)
  }]
})
api.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 400) {
    helper.clearLocalStorage()
    router.push('/login')
  }
  // if (error.response.status === 403) {
  //   swal(i18n.t('swal.sorry'), error.response.data.message, 'error')
  // }
  if (error.response.status === 404) {
    router.push('/404')
  }
  if (error.response.status === 500) {
    swal(i18n.t('swal.sorry'), i18n.t('swal.error'), 'error')
  }
  return Promise.reject(error.response)
})
export const HTTP = api



// WEBPACK FOOTER //
// ./src/CallAPI.js